"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionTimingFunction = exports.transitionDuration = exports.transition = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var transitionDuration = '350ms';
exports.transitionDuration = transitionDuration;
var transitionTimingFunction = 'cubic-bezier(0.375, 0, 0.675, 1)';
exports.transitionTimingFunction = transitionTimingFunction;
var transition = "".concat(transitionDuration, " ").concat(transitionTimingFunction);
exports.transition = transition;

var border = function border(width, color) {
  return "".concat(width, " solid ").concat(color);
};

var buttonTheme = function buttonTheme(theme) {
  var _theme$colors$system$ = theme.colors.system.cta,
      base = _theme$colors$system$.base,
      active = _theme$colors$system$.active,
      hover = _theme$colors$system$.hover;
  var _theme$colors$neutral = theme.colors.neutral,
      white = _theme$colors$neutral.white,
      quarter = _theme$colors$neutral.quarter,
      silverDollar = _theme$colors$neutral.silverDollar,
      nickel = _theme$colors$neutral.nickel;
  var nmBlue = theme.colors.primary.nmBlue;
  return _objectSpread({
    button: {
      primary: {
        backgroundColor: base,
        border: 'none',
        color: white,
        transition: "background-color ".concat(transition),
        hover: {
          backgroundColor: hover
        },
        active: {
          backgroundColor: active
        },
        focus: {
          backgroundColor: base
        },
        selected: {
          backgroundColor: silverDollar
        },
        working: {
          border: border('2px', white)
        },
        disabled: {
          backgroundColor: nickel,
          color: quarter
        },
        ghost: {
          color: white,
          backgroundColor: 'transparent',
          border: border('1px', white)
        }
      },
      secondary: {
        border: border('1px', quarter),
        backgroundColor: 'transparent',
        color: base,
        transition: "background-color ".concat(transition),
        hover: {
          border: border('1px', hover)
        },
        active: {},
        focus: {},
        selected: {
          backgroundColor: silverDollar,
          color: white
        },
        working: {
          border: border('2px', base)
        },
        disabled: {
          border: border('1px', '#E1E8ED'),
          color: quarter
        },
        ghost: {
          color: white,
          backgroundColor: 'transparent',
          border: 'none'
        }
      },
      tertiary: {
        backgroundColor: 'transparent',
        border: 'none',
        color: base,
        transition: "background-color ".concat(transition, ", color ").concat(transition),
        hover: {
          textDecoration: 'underline'
        },
        active: {
          textDecoration: 'underline'
        },
        focus: {},
        selected: {
          color: nmBlue
        },
        working: {
          border: border('2px', base)
        },
        disabled: {
          color: quarter
        },
        ghost: {
          color: white,
          backgroundColor: 'transparent',
          border: 'none'
        }
      }
    }
  }, theme);
};

var _default = buttonTheme;
exports.default = _default;
//# sourceMappingURL=button.js.map